var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJointServiceAchievement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 650,
    height: 250,
    viewBox: "0 0 650 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 250,
    fill: "#00155C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115,
    width: 80,
    height: 250,
    fill: "#24471A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455,
    width: 80,
    height: 250,
    fill: "#24471A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570,
    width: 80,
    height: 250,
    fill: "#00155C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    width: 35,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    width: 35,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    width: 35,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    width: 35,
    height: 250,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    width: 190,
    height: 250,
    fill: "#8DCFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 0H342V250H307V0Z",
    fill: "#C0162D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 650,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointServiceAchievement);
export default __webpack_public_path__ + "static/media/Joint Service Achievement.855fd8e9888c74611ebd99fa72fd76c5.svg";
export { ForwardRef as ReactComponent };